import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=4e15b864&"
import script from "./IconDownload.vue?vue&type=script&lang=js&"
export * from "./IconDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e15b864')) {
      api.createRecord('4e15b864', component.options)
    } else {
      api.reload('4e15b864', component.options)
    }
    module.hot.accept("./IconDownload.vue?vue&type=template&id=4e15b864&", function () {
      api.rerender('4e15b864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDownload.vue"
export default component.exports